import React from "react";
import { Link } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { LANDING_CONFIG, getEnvironmentConfig } from "../../config/landingConfig";
import OptimizedImage from "./OptimizedImage";

const HeroSection = () => {
  const { tenantLogo, tenantName } = getEnvironmentConfig();
  const { hero } = LANDING_CONFIG;

  return (
    <section className="hero-section">
      <div className="hero-background"></div>
      <div className="hero-content">
        {tenantLogo ? (
          <OptimizedImage
            src={tenantLogo}
            alt={`${tenantName} Logo`}
            className="hero-logo"
            loading="eager"
            placeholder={<div className="skeleton" style={{ width: '100px', height: '100px', borderRadius: '20px', background: 'rgba(255,255,255,0.1)' }} />}
          />
        ) : (
          <div className="hero-logo" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.1)',
            fontSize: '2rem',
            fontWeight: 'bold',
            color: 'white'
          }}>
            {tenantName.charAt(0).toUpperCase()}
          </div>
        )}
        <h1 className="hero-title">{hero.title}</h1>
        <p className="hero-subtitle">{hero.subtitle}</p>
        <p className="hero-description">{hero.description}</p>
        <div className="cta-buttons">
          <Link 
            to={hero.buttons[0].link}
            className={`cta-button ${hero.buttons[0].type}`}
            aria-label={`Access ${hero.buttons[0].text}`}
          >
            <PersonIcon style={{ marginRight: '8px' }} aria-hidden="true" />
            {hero.buttons[0].text}
          </Link>
          <Link 
            to={hero.buttons[1].link}
            className={`cta-button ${hero.buttons[1].type}`}
            aria-label={`Access ${hero.buttons[1].text}`}
          >
            <LocalHospitalIcon style={{ marginRight: '8px' }} aria-hidden="true" />
            {hero.buttons[1].text}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;